import { onGetWacInfoSuccess } from '../actions/internalActions';
import DocLinkPreviewInfo from '../store/schema/DocLinkPreviewInfo';
import store from '../store/store';
import { mutator } from 'satcheljs';

mutator(onGetWacInfoSuccess, actionMessage => {
    const { url, wacUrlInfo, needRedeem } = actionMessage;
    const previewInfo: DocLinkPreviewInfo = {
        time: Date.now(),
        wacUrlInfo,
        needRedeem,
    };

    store.docLinkPreviewInfoMap.set(url, previewInfo);
});
